import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: {},
});

function AddedItemCount(props) {
    const { equipments } = props;
    let count = 0;
    if (equipments["purchase_for"]) {
        Object.keys(equipments["purchase_for"]).map((slug) => {
            count += equipments["purchase_for"][slug].length;
        });
    }

    if (equipments["rent_for"]) {
        Object.keys(equipments["rent_for"]).map((slug) => {
            count += equipments["rent_for"][slug].length;
        });
    }

    if (equipments["lease_for"]) {
        Object.keys(equipments["lease_for"]).map((slug) => {
            count += equipments["lease_for"][slug].length;
        });
    }

    if (equipments["monthly_fee"]) {
        Object.keys(equipments["monthly_fee"]).map((slug) => {
            count += equipments["monthly_fee"][slug].length;
        });
    }

    if (equipments["apply_tpp"]) {
        Object.keys(equipments["apply_tpp"]).map((slug) => {
            count += equipments["apply_tpp"][slug].length;
        });
    }

    props.setEquipmentCount(count);

    return (
        <div className="modal-cart">
            <img src="/images/cart.png" alt="Cart" />
            <span>{count}</span>
        </div>
    );
}

export default AddedItemCount;
